import { useMutation, useQueryClient } from 'react-query';
import { apiClient, endpoints } from '../api/client';

export const updateExtensionWorkerMaxTabs = async (
  workerId: string,
  maxConcurrentTabs: number
): Promise<void> => {
  await apiClient.patch(`${endpoints.extensionWorkers}/${workerId}`, {
    max_concurrent_tabs: maxConcurrentTabs,
  });
};

export const useUpdateExtensionWorkerMaxTabs = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ workerId, maxConcurrentTabs }: { workerId: string; maxConcurrentTabs: number }) =>
      updateExtensionWorkerMaxTabs(workerId, maxConcurrentTabs),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('extensionWorkers');
      },
    }
  );
};
